import { DivAttrDetail } from './style';

interface AzimuthDetailProps {
  azimuthDeg: number | null;
}

export default function Azimuth({ azimuthDeg }: AzimuthDetailProps) {
	return (
		<DivAttrDetail id="azimuth">
			<label>Azimuth:</label>
			<span>{azimuthDeg ? Math.round(azimuthDeg) : 'N/A'}</span>
		</DivAttrDetail>
	);
}
